import {birdsData} from "./birds-data.js";
import {playAudio, pauseAudio, endedAudio, audio, imgSrc, progress} from "./audioplayer.js";
import * as answerList from "./answer-list.js";
import { localLanguageEn, localLanguageRu } from "./language.js";
import {findCurrentActiveQuestion} from './question.js';

const nameInDescription = document.querySelector('.bird-descr__name'),
      speciesInDescription = document.querySelector('.bird-descr__species'),
      descrInDescription = document.querySelector('.bird-descr__descr'),
      imageInDescription =  document.querySelector('.bird-descr__image'),
      audioInDescription = document.querySelector('.bird-descr__audio'),
      arrayVariant = document.querySelectorAll('.chose-answer__variant-text'),
      descrWrapper = document.querySelector('.bird-descr__wrapper'),
      descrBtn = document.getElementById('descr-button'),
      descrProgressCont = document.querySelector('.bird-descr-container-progress'),
      descrProgress = document.getElementById('test');

let divChoseYourVariant = document.createElement('div');
    divChoseYourVariant.classList.add('bird-descr__game-text');
if (descrWrapper !== null) {
  descrWrapper.appendChild(divChoseYourVariant);
  divChoseYourVariant.textContent = localStorage.getItem("lang") === null ?  localLanguageRu.game.text : localStorage.getItem("lang") === "Русский" ? localLanguageRu.game.text : localLanguageEn.game.text;
  divChoseYourVariant.classList.add = '.bird-descr__chose-variant';
  
  for (let i of descrWrapper.children) {
    if (i == divChoseYourVariant) {
      divChoseYourVariant.style.visibility = 'visible';
    } else {
      i.style.visibility = 'hidden';
    }
  }
}




function objectSearch (clickedBirdName) {
  for (let matrixRow = 0; matrixRow < birdsData.length; matrixRow++) {
    for (let matrixColumn = 0; matrixColumn < birdsData[matrixRow].length; matrixColumn++) {
      if (clickedBirdName == birdsData[matrixRow][matrixColumn].name) {
        let findedObject = birdsData[matrixRow][matrixColumn];

        for (let i of descrWrapper.children) {
          if (i == divChoseYourVariant) {
            divChoseYourVariant.style.visibility = 'hidden';
          } else {
            i.style.visibility = 'visible';
          }
        }
        
        setDescriptionWithItem(findedObject);
      }
    }
  }
}

function setDescriptionWithItem(item) {
  nameInDescription.innerHTML = item.name;
  nameInDescription.setAttribute('id', item.id);
  speciesInDescription.innerHTML = item.species;
  descrInDescription.innerHTML = item.description;
  imageInDescription.src = item.image;
  audioInDescription.src = item.audio;
  descrProgress.style.width = '0%';
  descrBtn.classList.remove('play');
  descrBtn.src = './assets/image/for-html/play_circle.png';
}

function loadDescriptionOfActualLang() {
  if (nameInDescription.getAttribute('id') !== undefined && nameInDescription.getAttribute('id') !== null) {
    let indexOfCategory = findCurrentActiveQuestion();
    let indexOfBird = + nameInDescription.getAttribute('id');
    setDescriptionWithItem(birdsData[indexOfCategory][indexOfBird - 1]);
  }
}

for (let name of arrayVariant) {
  name.addEventListener('click', () => {
    const clickedBirdName = name.textContent;

    objectSearch(clickedBirdName);
  })
}

if (descrBtn !== null) {
  descrBtn.addEventListener('click', () => {
    const isPlaying = descrBtn.classList.contains('play');
  
    if (isPlaying) {
      pauseAudio (descrBtn, audioInDescription);
    } else {
      if (imgSrc.classList.contains('play')) {
        pauseAudio(imgSrc, audio);
      }
      playAudio (descrBtn, audioInDescription);
    }
  })
}


function updateProgressDescr (event) {
  const duration = event.srcElement.duration, 
    currentTime = event.srcElement.currentTime,
    progressPercent = currentTime / duration * 100;
    
    descrProgress.style.width = `${progressPercent}%`;
}

if (audioInDescription !== null) {
  audioInDescription.addEventListener('timeupdate', updateProgressDescr);
}

function setProgress (event) {
  const width = this.clientWidth,
        clickX = event.offsetX,
        duration = audioInDescription.duration;

        audioInDescription.currentTime = clickX / width * duration;
}

if (descrProgressCont !== null) {
  descrProgressCont.addEventListener('click', setProgress);
}

endedAudio (descrBtn, audioInDescription);

export {descrBtn, audioInDescription, descrWrapper, descrProgress, loadDescriptionOfActualLang};